// extracted by mini-css-extract-plugin
export var quantityInput = "_mr-0";